import React, { memo } from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';
import CloseIcon from '@material-ui/icons/Close';
import { colors } from '../../../constants/styleConstants';
import { useTranslation } from '../../../src/i18n';
import SubmitModalLayout from '../../SubmitModalLayout';
import FileInput from '../../FileInput';
import { TP } from '../../../constants/consts';
import ImageTag from '../../ImageTag';
import { joinMediaFormats } from '../../../utils/editCommon';

const useStyles = makeStyles(theme => ({
  root: {
    padding: '24px 16px',
    display: 'flex',
    [theme.breakpoints.down('sm')]: {
      flexDirection: 'column',
      width: '100%',
      alignItems: 'center',
    },
  },
  imageBlock: {
    marginLeft: '31px',
    boxShadow: '0 2px 10px 0 rgba(0, 0, 0, 0.2)',
    height: '220px',
    position: 'relative',
    [theme.breakpoints.down('sm')]: {
      marginLeft: 0,
    },
  },
  image: {
    height: '100%',
    [theme.breakpoints.down('xs')]: {
      height: 'auto',
      width: '100%',
    },
  },
  closeIcon: {
    position: 'absolute',
    top: '5px',
    right: '5px',
    cursor: 'pointer',
    backgroundColor: colors.white,
    borderRadius: '50%',
  },
  modal: {
    top: '25%',
  },
}));

const UploadImageModal = ({ onClose, imageUrl, submitImage, title, isLoading, formats }) => {
  const classes = useStyles();
  const { t } = useTranslation();

  const [image, setImage] = React.useState(null);

  React.useEffect(() => {
    if (imageUrl.length) {
      setImage({ filename: '', content: imageUrl });
    }
  }, [imageUrl]);

  const saveImage = () => {
    if (image.file || image.filename) {
      submitImage({ content: image.content.split(',')[1], file: image.file, filename: image.filename });
    } else {
      onClose();
    }
  };

  return (
    <SubmitModalLayout
      isOpened
      onClose={onClose}
      title1={t(title)}
      title2={t(`${TP}.FN_ACCEPTING_FORMATS`, { formats: joinMediaFormats(formats) })}
      disableBackdropClick
      className={classes.modal}
      withoutFooter={!image}
      submitFunc={saveImage}
      isLoading={isLoading}
    >
      <div className={classes.root}>
        <FileInput
          onImageUpload={data => {
            setImage(data);
          }}
          formats={formats}
        />
        {image && (
          <div className={classes.imageBlock}>
            <ImageTag className={classes.image} src={image.content} alt="img" />
            <CloseIcon className={classes.closeIcon} onClick={() => setImage(null)} />
          </div>
        )}
      </div>
    </SubmitModalLayout>
  );
};

UploadImageModal.propTypes = {
  onClose: PropTypes.func.isRequired,
  imageUrl: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
  submitImage: PropTypes.func.isRequired,
  title: PropTypes.string,
  isLoading: PropTypes.bool,
  formats: PropTypes.array,
};

UploadImageModal.defaultProps = {
  imageUrl: null,
  title: `edit:${TP}.FN_EDITARTIST_ADD_IMAGE`,
  isLoading: false,
  formats: ['jpg'],
};

export default memo(UploadImageModal);
